<ng-container *transloco="let t;">
    <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel1">{{t("Qrcode modal title (Signing page - section) - Sign the document")}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="cancelBankid()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body pt-2" tabindex="0" ngbAutofocus>
        <div class="row m-0">
            <div class="col-md-7 col-lg-7 col-12">
                <div class="row">
                    <div class="d-flex flex-column gap-1">
                        <div>1. {{t("Qrcode modal text for open bankid (Signing page - section) - Open your Mobile BankID Application")}}.</div>
                        <div>2. {{t("Qrcode modal text for scan qrcode (Signing page - section) - Scan QR code with BankID QR code scanner")}}.</div>
                        <div>3. {{t("Qrcode modal text for camera (Signing page - section) - Point your camera on the QR code")}}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 col-lg-5 col-12">
                @if(qrcode){
                    <qrcode [qrdata]="qrcode" [width]="256" [errorCorrectionLevel]="'M'" [allowEmptyString]="true"></qrcode>
                }
            </div>
        </div>
    </div>
</ng-container>